/**
 * HpMediaGallery Custom Element
 * Initializes a Swiper slider with a thumbnail navigation slider.
 */
if (!customElements.get("hp-media-gallery")) {
  class HpMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.mainSliderEl = this.querySelector('[data-component="main-slider"]');
      this.thumbsSliderEl = this.querySelector(
        '[data-component="thumbs-slider"]',
      );
      this.mainSwiper = null;
      this.thumbsSwiper = null;
    }

    connectedCallback() {
      if (!window.Swiper) {
        // If Swiper isn't loaded yet, wait for it or you might want to load it dynamically.
        // Assuming it's globally available via defer scripts.
        window.addEventListener("load", this.init.bind(this), { once: true });
        return;
      }
      this.init();
    }

    disconnectedCallback() {
      if (this.mainSwiper) this.mainSwiper.destroy();
      if (this.thumbsSwiper) this.thumbsSwiper.destroy();
    }

  //   init() {
  //     if (!window.Swiper || !this.mainSliderEl) return;

  //     if (this.thumbsSliderEl) {
  //       this.thumbsSwiper = new window.Swiper(this.thumbsSliderEl, {
  //         spaceBetween: 12,
  //         slidesPerView: 3,
  //         freeMode: true,
  //         watchSlidesProgress: true,
  //       });
  //     }

  //     this.mainSwiper = new window.Swiper(this.mainSliderEl, {
  //       spaceBetween: 16,
  //       slidesPerView: 1,
  //       thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined,
  //       grabCursor: true,
  //     });
  //   }
  // }

      init() {
        if (!window.Swiper || !this.mainSliderEl) return;

        if (this.thumbsSliderEl) {
          const thumbnailCount = Number(
            this.thumbsSliderEl.dataset.thumbnailCount || 1,
          );

          this.thumbsSwiper = new window.Swiper(this.thumbsSliderEl, {
            spaceBetween: 12,
            slidesPerView: Math.min(thumbnailCount, 6),
            freeMode: true,
            watchSlidesProgress: true,
          });
        }

        this.mainSwiper = new window.Swiper(this.mainSliderEl, {
          spaceBetween: 16,
          slidesPerView: 1,
          thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined,
          grabCursor: true,
        });
      }
    }

  customElements.define("hp-media-gallery", HpMediaGallery);
}
